import { State } from '@/helpers/entities/enums/v2/State';
import { EcommerceProductOptionInputModel } from '@/helpers/entities/models/EcommerceProductOptionInputModel';
import { EcommerceProductSectionModel } from '@/helpers/entities/models/EcommerceProductSectionModel';
export class EcommerceProductSectionInputModel {
    constructor(payload = null) {
        if (payload) {
            Object.assign(this, payload);
            this.options = [];
            if (payload.published) {
                this.state = State.idle;
            }
            else {
                this.state = State.hidden;
            }
            if (payload instanceof EcommerceProductSectionModel) {
                const optionModel = (po) => {
                    return new EcommerceProductOptionInputModel(po);
                };
                this.productOptions = payload.productOptions.map(optionModel);
                this.productOptions.forEach((po) => {
                    po.sectionName = this.name;
                });
            }
            else {
                const optionModel = (po) => {
                    return new EcommerceProductOptionInputModel(po.node);
                };
                const options = payload.productOptions;
                this.productOptions = options.edges.map(optionModel);
                this.productOptions.forEach((po) => {
                    po.sectionName = this.name;
                });
            }
            const withName = (po) => {
                return po.name != null;
            };
            const productOptionWithName = this.productOptions.filter(withName);
            productOptionWithName.forEach((po) => {
                this.options.push(po.name);
            });
        }
        else {
            this.init();
        }
    }
    markAsDeleted() {
        this.state = State.deleted;
    }
    get isDeleted() {
        return this.state === State.deleted;
    }
    get getDeletedOptionUuids() {
        const deleted = (po) => po.deleted && !!po.uuid;
        return this.productOptions
            .filter(deleted)
            .map((po) => po.uuid);
    }
    get getHiddenOptionUuids() {
        const hidden = (po) => po.state === State.hidden && !!po.uuid;
        return this.productOptions
            .filter(hidden)
            .map((po) => po.uuid);
    }
    onOptionsChanged(sectionName, options, basePrice) {
        const productOptions = this.productOptions.map((po) => po.name);
        options.forEach((name) => {
            if (!productOptions.includes(name)) {
                const option = new EcommerceProductOptionInputModel();
                option.setName(name);
                option.setSectionName(sectionName);
                option.setPrice(basePrice);
                this.productOptions.push(option);
            }
        });
        // Only delete newly added product variance.
        // Existing product variance will only be hidden.
        const deleted = (po) => !options.includes(po.name) && po.state === 'new';
        const hidden = (po) => !options.includes(po.name) && po.state === 'idle';
        this.productOptions
            .filter(deleted)
            .forEach((po) => po.markAsDeleted());
        this.productOptions
            .filter(hidden)
            .forEach((po) => po.markAsHidden());
        const deletedOptions = this.productOptions.filter((po) => {
            return po.deleted;
        });
        const hiddenOptions = this.productOptions.filter((po) => {
            return po.hidden;
        });
        // In case of duplicate value revert option previous state
        deletedOptions.forEach((po) => {
            if (options.includes(po.name)) {
                if (po.uuid) {
                    po.markAsIdle();
                }
                else {
                    po.markAsNew();
                }
            }
        });
        hiddenOptions.forEach((po) => {
            if (options.includes(po.name)) {
                if (po.uuid) {
                    po.markAsIdle();
                }
            }
        });
        this.options = options;
    }
    buildNewOptionsParams() {
        return this.productOptions.map((po) => {
            const { name, price, compareAtPrice, limited, stockQuantity, published, sectionName, digitalProduct, } = po;
            return {
                name,
                price: Number(price),
                compareAtPrice: Number(compareAtPrice),
                limited,
                stockQuantity: Number(stockQuantity),
                published,
                sectionName,
                digitalProduct,
            };
        });
    }
    buildOptionsParams() {
        const notDeleted = (po) => !po.deleted;
        const options = this.productOptions.filter(notDeleted);
        return options.map((po) => {
            const { uuid, name, price, compareAtPrice, limited, stockQuantity, published, sectionName, digitalProduct, } = po;
            let option = {
                name,
                price: Number(price),
                compareAtPrice: Number(compareAtPrice),
                limited,
                stockQuantity: Number(stockQuantity),
                published,
                sectionName,
                digitalProduct,
            };
            if (!po.fresh) {
                option = {
                    ...option,
                    productOptionUuid: uuid,
                };
            }
            return option;
        });
    }
    init() {
        this.uuid = null;
        this.name = '';
        this.state = State.new;
        this.productOptions = [];
        this.options = [];
        this.published = true;
    }
}
